import React, { useState, useEffect } from "react";
import { Table, Card, Col, Row, Form } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const UserLeaveData = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page_size, setpage_size] = useState("all");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    fetchUsers();
  }, [page, page_size]);

  const filterUsersByRole = (users) => {
    const role = localStorage.getItem("role");

    if (role === "admin") {
      return users.filter(
        (user) =>
          user.role === "agent" ||
          user.role === "superuser" ||
          user.role === "technician"
      );
    } else if (role === "superuser") {
      return users.filter(
        (user) => user.role === "agent" || user.role === "technician"
      );
    }
    return [];
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/users/tms_users/`, {
        headers: HEADERS,
        params: {
          page: page,
          page_size: page_size,
        },
      });

      if (response.data && response.data.results) {
        const filteredUsers = filterUsersByRole(response.data.results);
        setUsers(filteredUsers);
        setTotalPages(response.data.total_pages);
      } else {
      }
    } catch (error) {
      toast.error("Failed to fetch user data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlepage_sizeChange = (e) => {
    const value = e.target.value === "all" ? "all" : Number(e.target.value);
    setpage_size(value);
    setPage(1);
  };

  const calculateSNo = (index) => {
    if (page_size === "all") {
      return index + 1;
    } else {
      return (page - 1) * page_size + (index + 1);
    }
  };

  return (
    <Card className="shadow-sm border-light">
      <Card.Header className="d-flex justify-content-between align-items-center bg-light border-bottom">
        <h5 className="mb-0">User Leave Data</h5>
      </Card.Header>
      <Card.Body>
        <Row className="mb-3">
          <Col>
            <Form.Group controlId="recordsPerPage">
              <Form.Label>Show</Form.Label>
              <Form.Control
                as="select"
                value={page_size}
                onChange={handlepage_sizeChange}
                style={{
                  width: "auto",
                  display: "inline-block",
                  marginLeft: "10px",
                }}
              >
                <option value="all">All</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </Form.Control>
              <span> records per page</span>
            </Form.Group>
          </Col>
        </Row>
        {loading ? (
          <Loader />
        ) : users.length === 0 ? (
          <div className="text-center text-muted">No user data found</div>
        ) : (
          <Table striped hover responsive className="text-center">
            <thead className="table-light">
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Profile</th>
                <th>Casual Leaves</th>
                <th>Sick Leaves</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{calculateSNo(index)}</td>
                  <td>
                    {user.first_name} {user.last_name}
                  </td>
                  <td>{user.role}</td>
                  <td>{user.allocated_casual_leave || "N/A"}</td>
                  <td>{user.allocated_sick_leave || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default UserLeaveData;
